<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 10.9782C0 12.2014 0.220039 13.3731 0.621992 14.4564L10 15.326L19.378 14.4564C19.78 13.3731 20 12.2014 20 10.9782C20 9.75498 19.78 8.58326 19.378 7.49994L10 6.63037L0.621992 7.49994C0.220039 8.58326 0 9.75498 0 10.9782Z"
            fill="#FFDA44"
        />
        <path
            d="M0.62207 14.457C2.035 18.265 5.70043 20.9788 10.0001 20.9788C14.2997 20.9788 17.9652 18.265 19.3781 14.457H0.62207Z"
            fill="#D80027"
        />
        <path
            d="M19.3781 7.50027C17.9652 3.6923 14.2997 0.978516 10.0001 0.978516C5.70043 0.978516 2.035 3.6923 0.62207 7.50027H19.3781Z"
            fill="#D80027"
        />
    </svg>
</template>